import { LoanTooSmallContactInfo } from '../../cards/contact-info-short/small-loan';
import { DownPaymentTooSmall } from '../../cards/down-payment-too-small';
import EarlyKickOut from '../../cards/early-kick-out';
import { Branch, Card, End } from '../../components/deck';
import { evaluateDownPayment, MIN_DOWN_PAYMENT_SIZES } from '../../modules/down-payment-evaluation';
import { isPurchaseLargeEnough } from '../../modules/loan-size';

/**
 * Map over the list of {@see MIN_DOWN_PAYMENT_SIZES} and produce a mapping
 *   of that state to a card that represents it.
 *
 * For use in the branch path declarations below.
 */
const downPaymentEvalPaths = Object.keys(MIN_DOWN_PAYMENT_SIZES).reduce((acc, cur) => {
  acc[cur] = Card(DownPaymentTooSmall(cur), End());
  return acc;
}, {});

/**
 * Determines if your down payment is too small based on your scenario
 *   and minimum down payment rules and hard-stops you if you do not
 *   meet the requirements.
 *
 * {@see MIN_DOWN_PAYMENT_SIZES} for rulesets.
 *
 * @param {*} continuation - Path to continue on if validation passes
 */
export const DownPaymentEvaluationBranch = (continuation) =>
  Branch(
    {
      tooSmall: Card(LoanTooSmallContactInfo, Card(EarlyKickOut))
    },
    ({ model }) => (!isPurchaseLargeEnough(model) ? 'tooSmall' : null),
    Branch(downPaymentEvalPaths, ({ model }) => evaluateDownPayment(model), continuation)
  );



// WEBPACK FOOTER //
// ./src/decks/branches/down-payment-evaluation.js